import MediaGallery from "../../Components/MediaGallery";
import { Button, CircularProgress, Grid, Typography } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Title from "../../Components/Title";
import { getToken, requestErrorHandler } from "../../Utils/Common";
import EnvSettings from "../../Utils/EnvSettings";
import { useStyles } from "../../Utils/Styles";
import { showPopupSnackbar } from "../../redux/actions/snackbarActions";
const server = EnvSettings.server;

export default function ProductionPhotos({ device_id, manufacturing_id }) {
  const classes = useStyles();
  const [checklistURL, setChecklistURL] = useState();
  const [loading, setLoading] = useState(false);
  const [listError, setListError] = useState(false);
  const listRequest = useRef();
  const [files, setFiles] = useState();
  const [fileToDelete, setFileToDelete] = useState();
  const { t } = useTranslation();

  const fileUploadRef = useRef();

  const dispatch = useDispatch();

  const getPhotos = () => {
    if (listRequest.current) listRequest.current.abort();
    const controller = new AbortController();
    listRequest.current = controller;
    setLoading(true);
    setListError(false);
    setChecklistURL();
    const requestOptions = {
      method: "POST",
      signal: controller.signal,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        deviceid: device_id,
        manufacturing_id: manufacturing_id,
      }),
    };
    fetch(server + "/get_production_photos", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (controller.signal.aborted) return;
        setListError(!!result.error);
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          if (result.files) {
            setChecklistURL(result);
          }
        }
      }).catch(() => {
        if (!controller.signal.aborted) setListError(true);
      }).finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });
  };

  useEffect(() => {
    getPhotos();
    return () => { if (listRequest.current) listRequest.current.abort(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [device_id, dispatch]);

  const uploadPhoto = (e) => {
    if (!files || !files.length) {
      return;
    }
    const data = new FormData();
    data.append("token", getToken());
    files.forEach((element) => {
      data.append("files[]", element);
    });
    data.append("device_id", device_id);
    data.append("manufacturing_id", manufacturing_id);
    fetch(server + "/upload_production_photos", {
      method: "POST",
      // headers: {
      //   "content-type": file.type,
      //   "content-length": `${file.size}`, // 👈 Headers need to be a string
      // },
      body: data,
    })
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        dispatch(showPopupSnackbar(result));
        if (!result.error) {
          getPhotos();
          fileUploadRef.current.value = null;
          setFiles([]);
        }
      });
  };

  const removePhoto = () => {
    if (!fileToDelete || !device_id) {
      return;
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        filename: fileToDelete,
        device_id: device_id,
        manufacturing_id: manufacturing_id,
      }),
    };
    fetch(server + "/delete_production_photo", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          dispatch(showPopupSnackbar(result));
        }

        getPhotos();
      });
  };

  const handleClose = () => {
    setFileToDelete(undefined);
  };

  return (
    <Grid container spacing={3}>
      <Dialog
        open={fileToDelete ? true : false}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t("delete")} {fileToDelete}?
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t("cancel")}
          </Button>
          <Button
            onClick={() => {
              removePhoto();
              handleClose();
            }}
            color="primary"
            autoFocus
          >
            {t("delete")}
          </Button>
        </DialogActions>
      </Dialog>
      <Grid container spacing={3} item xs={12}>
        <Grid item xs={12}>
          <Title>{t("productionPhotos")}</Title>
        </Grid>
        {loading ? (
          <Grid item xs={12}><CircularProgress size={24} aria-label={t("mediaPreview.loading")} /></Grid>
        ) : listError ? (
          <Grid item xs={12}>
            <Typography color="error" role="alert">{t("mediaPreview.listFailed")}</Typography>
            <Button onClick={getPhotos}>{t("mediaPreview.retry")}</Button>
          </Grid>
        ) : checklistURL && checklistURL.attachments?.length ? (
          <Grid item xs={12}>
            <MediaGallery attachments={checklistURL.attachments}
              deviceid={device_id} onDelete={setFileToDelete} />
          </Grid>
        ) : (
          <Grid item><Typography>{t("noPhotosAvailable")}</Typography></Grid>
        )}
      </Grid>
      <Grid container item xs={12} sm={6}>
        <Grid item xs={12}>
          <Title>{t("uploadNewPhotos")}</Title>
        </Grid>
        <Grid item>
          <input
            accept="image/*"
            className={classes.input}
            id="contained-button-file"
            type="file"
            multiple
            onChange={(e) => {
              if (e.target.files) {
                setFiles(Array.prototype.slice.call(e.target.files));
              }
            }}
            ref={fileUploadRef}
          />
        </Grid>
        <Grid item>
          <label htmlFor="contained-button-file">
            <Button
              variant="outlined"
              disabled={!(files && files.length) ? true : false}
              onClick={uploadPhoto}
            >
              {t("uploadPhotos")}
            </Button>
          </label>
        </Grid>
      </Grid>
    </Grid>
  );
}
